<template>
  <div class="paper-assess-page">
    <div class="page-title">
      <div class="words-box">
        <span class="title">教师点评</span>
        <el-button
                v-if="!is_view"
                type="primary"
                size="small"
                icon="el-icon-info"
                @click="goCorrectExplainView"
                >
            批改说明
        </el-button>
        <span class="name">试题：{{paperName}}</span>
      </div>
      <div class="button-box" v-if="!is_view">
        <el-button
                type="primary"
                size="middle"
                plain
                @click="cancel"
                >
            取消
        </el-button>
        <el-button
                type="primary"
                size="middle"
                @click="save"
                >
            保存
        </el-button>
      </div>
    </div>
    <div class="page-content">
      <div class="part" v-if="need_score == 1">
        <div class="part-title">
          教师评分<font class="red" v-if="!is_view">*</font>
        </div>
        <div class="part-content" v-if="!is_view">
          <el-input-number v-model="num" controls-position="right" size="small" step-strictly :step="0.1" :min="0" placeholder="请输入" @blur="check"></el-input-number>
          <span class="red font-12" v-show="err_msg">{{err_msg}}</span>
        </div>
        <div class="part-content" v-else>
          <span>{{num}}分</span>
        </div>
      </div>
      <div class="part" v-if="!comment_mode.includes('0') && comment_mode.includes('3')">
        <div class="part-title">
          答题卡批改<font class="red" v-if="!is_view">*</font>
        </div>
        <div class="part-content">
          <el-upload
            :class="is_view ? 'is_view' : ''"
            ref="upload"
            :action="uploadUrl"
            list-type="picture-card"
            :http-request="uploadFile"
            :file-list="local_pic_arr"
            :before-upload="beforeUpload"
            auto-upload>
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!is_view"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
          </el-upload>
          <span v-if="is_view && !local_pic_arr.length">无</span>
          <span class="red font-12" v-show="pic_err_msg">{{pic_err_msg}}</span>
        </div>
      </div>
      <div class="part" v-if="!comment_mode.includes('0') && comment_mode.includes('2')">
        <div class="part-title">
          视频点评<font class="red">*</font>
        </div>
        <div class="part-content">
          <span v-show="video_upload_status == 1 && !is_view " class="font-video">
            <img class="icon-v rotate-self" src="../../../static/images/video_loading.png" alt="" />
            视频上传中...
            <span class="video-style">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span v-show="video_upload_status == 2 && !is_view" class="font-video">
              <img class="icon-v" src="../../../static/images/video_no.png" alt="">视频上传失败 &nbsp;&nbsp;&nbsp;&nbsp;
              <span >
                  <span @click="tryAgain" class="video-style"> 重试</span> |
                  <span @click="cancelVideo" class="video-style">删除</span>
              </span>
          </span>
          <span v-show="upload.media_id" class="upload-success rela">
              <span class="upload-success-info">
                  <span class="upload-success-id">({{ upload.media_id  }})</span>
                   <span @click="viewVideo" class="upload-success-url">{{ upload.name }}
                  </span>
              <span class="el-icon-close" v-show="!is_view" @click="deleteLocal"></span>
              </span>
          </span>
          <el-button
          v-show="!is_view && (video_upload_status== 0 || video_upload_status== 3)"
          type="primary"
          plain
          size="middle"
          @click="relationVideo"
          >
            {{!upload.media_id ? '关联视频' : '重新关联'}}
          </el-button>
          <span v-show="!is_view && (video_upload_status== 0 || video_upload_status== 3)" class="no-video">没有合适的视频？
            <span class="video-style" @click="RecordVideoOpen" v-show = "video_upload_status== 0 && !upload.media_id">录制视频</span>
            <span class="video-style" v-show="video_upload_status== 3 || upload.media_id" @click="notUpload('1')">录制视频</span> 或
            <span class="video-style" >
                <el-button type="text" v-show="video_upload_status== 3 || upload.media_id" @click="notUpload">本地上传</el-button>
                <el-upload
                  v-show = "video_upload_status== 0 && !upload.media_id"
                  class="upload-demo import-dialog video-upload"
                  accept=".mp4"
                  action="#"
                  ref="upload_video"
                  :on-change = "selectFileInfo"
                  :auto-upload=false
                  :show-file-list=false
                >
                  <el-button type="text" id="video-button">本地上传</el-button>
                </el-upload>
            </span>
          </span>

          <record-video :value.sync="RecordVideo" :maxRecordTime="300" @uploadFile="videoUpload" @errorLister="errorLister"></record-video>
          <!-- <a @click="RecordVideoOpen">录制视频</a> -->
        </div>
      </div>
      <div class="part" v-if="!comment_mode.includes('0') && comment_mode.includes('1')">
        <div class="part-title">
          文字点评<font class="red">*</font>
        </div>
        <div class="part-content">
          <div class="item-title" v-show="question_mode == 0">
            总体评价
          </div>
          <div class="item-content" v-show="question_mode < 1">
            <ueditor id="ueditor_1" :config="config" ref="ueditor_1"></ueditor>
          </div>
          <div class="item-title" v-show="question_mode > -1">
            问题
          </div>
          <div class="item-content" v-show="question_mode > -1">
            <ueditor id="ueditor_2" :config="config" ref="ueditor_2"></ueditor>
          </div>
          <div class="item-title" v-show="question_mode == 0">
            优点
          </div>
          <div class="item-content" v-show="question_mode == 0">
            <ueditor id="ueditor_3" :config="config" ref="ueditor_3"></ueditor>
          </div>
          <div class="item-title" v-show="question_mode == 0">
            建议
          </div>
          <div class="item-content" v-show="question_mode == 0">
            <ueditor id="ueditor_4" :config="config" ref="ueditor_4"></ueditor>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog :title="!upload.media_id ? '关联视频' : '重新关联'" :visible.sync="dialogFormVisible">
      <el-form :model="videoForm" ref="form">
        <el-form-item label="MediaID" prop="media_id" :rules="rules">
          <el-input v-model="videoForm.media_id" autocomplete="off" @input="inputErrorMessage = false"></el-input>
          <div v-if="inputErrorMessage" class="inputErrorMessage">Media-ID不存在</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="check_media">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Ueditor from '@/components/ueditor'
import RecordVideo from '@/components/record-video'
import global_ from "../../global/index"
import axios from 'axios'
import * as qiniu from 'qiniu-js'

export default {
  components: {
    Ueditor,
    RecordVideo
  },
  data () {
    return {
      rules: [
        { required: true, message: '请输入Media-ID' }
      ],
      dialogFormVisible: false,
      video_upload_status: 0, // 上传状态
      upload:{
          media_id:'',
          url:'',
          file: null,
          type: null
      },
      videoForm: {
        media_id: ''
      },
      isAdd: false,
      RecordVideo: false,
      question_mode: 0,
      pic_err_msg: '',
      err_msg: '',
      question_evaluation: '',
      question_issue: '',
      question_merit: '',
      question_advice: '',
      uploadUrl: '',
      writConfig: {
        // enableAutoSave: false,
        readonly: false,
        initialFrameWidth: '100%',
        initialFrameHeight: 200,
        elementPathEnabled: false, // 不显示元素路径
        zIndex: 9,
        maximumWords: 500,
        toolbars: [[
            'underline',
            // 'simpleupload',
            'spechars',
            'kityformula',
            // 'fontpoint',
            'emptyunderline'
        ]],
        enterTag : 'br',
        // serverUrl: 'http://35.201.165.105:8000/controller.php'
      },
      is_view: false,
      paperName: '',
      // 试题总分
      max_score: 100,
      need_score: 1, // 是否需要判分 1：是，2：否
      comment_mode: [], // 点评方式 0无点评方式，老师不用去进行教师点评  1 文字 2 视频 3 答题卡批改 可以自由组合，逗号分隔,
      // 学生答题卡数量
      user_answer_sheet_length: 0,
      num: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      local_pic_arr: [
          // {
          //     name: 'http://s.eoffcn.com/tiku/answersheet/20190918/Android_06fff5e61b9e520b551ae7b5850ebd4f.jpg',
          //     url: 'http://s.eoffcn.com/tiku/answersheet/20190918/Android_06fff5e61b9e520b551ae7b5850ebd4f.jpg'
          // }
      ],
      http_pic_arr: [],
      pic_toast: false,
      text_remark_id: null,
      sts: {
        accessKeyID: '',
        secretAccessKey: '',
        sessionToken: '',
        url: '',
        endpoint: ''
      },
      inputErrorMessage: false,
      qiniuToken: ''
    }
  },
  computed: {
    config () {
      return this.writConfig;
    }
  },
  created () {
    window.utils.documentSetTitle('教师点评');
    if (process.env.NODE_ENV=='production') {
      this.uploadUrl = global_.global.online_url + '/api/admin/library/uploadImg'
    } else if (process.env.NODE_ENV=='testing') {
      this.uploadUrl = global_.global.test_url + '/api/admin/library/uploadImg'
    } else {
      this.uploadUrl = global_.global.local_url + '/api/admin/library/uploadImg'
    }
    // this.paperName = window.localStorage.getItem(`exercise_name${this.$route.params.record_id}`) + ' - ' + this.$route.params.question_num;
    this.paperName = this.$route.params.exercise_name + ' - ' + this.$route.params.question_num;
    this.need_score = Number(this.$route.params.need_score);
    this.max_score = Number(this.$route.params.question_score);
    this.user_answer_sheet_length = this.$route.params.cardsNum || 0;
    this.question_mode = Number(this.$route.params.score_mode);
    this.comment_mode = this.$route.params.comment_mode.split(',');
    this.getPaperStatus(this.$route.params.record_id, () => {
      this.getPaperCorrectResult();
      if (!this.is_view) {
        this.getUserCorrectExplain();
        this.getQiniuToken()
        this.getBaiduVideosToken();
      } else {
        // 富文本编辑器只读
        this.writConfig.readonly = true;
      }
    })
  },
  methods: {
    // 关联视频
    relationVideo () {
      if (this.upload.media_id) {
        this.notUpload(2);
      } else {
        this.dialogFormVisible = true;
        this.inputErrorMessage = false;
      }
    },
    getQiniuToken () {
      this.$api.GETQINIUTOKEN({}).then(res => {
        console.log(res)
        if (res.retcode === 0) {
          this.qiniuToken = res.data
        }
      })
    },
    check_media () {
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.$api.GETMEDIAURL({mediaId: this.videoForm.media_id}).then(res => {
              if (res.retcode == 0) {
                this.upload.media_id = res.data.id;
                this.upload.url = res.data.url;
                this.upload.name = res.data.id;
                this.dialogFormVisible = false;
                this.videoForm.media_id = '';
              } else if (res.retcode == 10005 && res.message.indexOf('媒资不存在') > -1) {
                this.inputErrorMessage = true
              } else {
                this.$message.error(res.message);
              }
            }).catch(error => {
              console.log(error);
            })
        }
      })
    },
    getBaiduVideosToken () {
      this.$api.GETBAIDUVIDEOTOKEN({}).then(res => {
        if (res.retcode!=0){
            this.$message.error(res.message);
        }else {
            this.sts = res.data;
        }
      })
    },
    selectFileInfo (file) {
        console.log(file)
        // this.getSecret(file)
        this.upload.file = file;
        this.fileUploadQiNiu(file);

    },
    notUpload (type) {
        let that = this;

        that.$confirm('该操作会导致原视频被覆盖，确定要继续吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass:'video-know-position',
          dangerouslyUseHTMLString: true,
          showClose:false,
          showCancelButton:true,
          closeOnClickModal:false,
          type: 'error'
        }).then(() => {
            if(type==1){
                that.RecordVideo = true;
            }else if (type==2) {
                that.dialogFormVisible = true;
                that.inputErrorMessage = false;
            }else{
                document.getElementById("video-button").click();
            }

        }).catch(() => {
        });
    },
    tryAgain () {
        console.log('重新尝试-----', this.upload.file, this.upload.type);
        this.fileUploadQiNiu(this.upload.file, this.upload.type);
    },
    cancelVideo () {
        this.video_upload_status = 0;
        this.upload.file = null;
        this.upload.url = null;
    },
    viewVideo () {
        let vidoe_window = window.open("");
        let href =  this.$router.resolve({
                path:'/video-preview/'+ this.upload.media_id
            })
        vidoe_window.location = href.href;

    },
    deleteLocal () {
        this.$confirm('<div>确定要删除视频吗？</div>', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass:'know-position video-know-position',
          dangerouslyUseHTMLString: true,
          showClose:false,
          showCancelButton:true,
          closeOnClickModal:false,
          type: 'warning'
        }).then(() => {
            this.video_upload_status = 0;
            this.upload.file = null;
            this.upload.media_id = null;
            this.upload.url = null;
            this.videoForm.media_id = '';
        }).catch(() => {
        });
    },
    // 生成日期目录
    getFolderName () {
      let date = new Date()
      return date.getFullYear() + ('0' + String(date.getMonth() + 1)).substr(-2) + ('0' + String(date.getDate())).substr(-2)
    },
    mediaCreate (type, fetchKey, name) {
      let params = {
        type, // 10 视频
        name,
        fetchKey
      }
      this.$api.MEDIACREATE(params).then(res => {
        console.log(res)
        if (res.retcode === 0) {
          this.upload.media_id = res.data.id
          this.upload.name = res.data.name
        }
      })
    },
    fileUploadQiNiu (file, type,) {
      this.video_upload_status = 1;
      this.upload.media_id = null;
      this.upload.url = null;
      let file_name = ''
      let file_blob = ''
      if (type == 1){
          file_name  = '录制视频'
          file_blob = file.blob;
      } else {
          file_name  = file.name;
          file_blob = file.raw;
      }
      let that = this
      console.log(file_name)
      const key = `upload/${this.getFolderName()}/${new Date().getTime()}/${file_name}`
      const observable = qiniu.upload(file_blob, key, this.qiniuToken)
      const observer = {
        next(res){
          // console.log('next::', res)
        },
        error(err){
          console.log('err::', err)
          that.video_upload_status = 2
        },
        complete(res){
          console.log('complete::', res)
          that.video_upload_status = 3
          that.mediaCreate(10, res.key, file_name)
        }
      }
      const subscription = observable.subscribe(observer) // 上传开始
    },
    getNumber () {
        return Math.floor(Math.random() * (99999 - 10000)) + 10000
    },
    fileUpload (file, type) {

        this.video_upload_status = 1;
        this.upload.media_id = null;
        this.upload.url = null;
        console.log('shanghcuan')

        var sdk = baidubce.sdk;
        var VodClient = sdk.VodClient;

        // var config = {
        //     credentials: {
        //             ak: this.sts.accessKeyID,
        //             sk: this.sts.secretAccessKey
        //     },
        //     endpoint: this.sts.endpoint,
        //     sessionToken: this.sts.sessionToken
        // };
        var bosConfig = {
            credentials: {
                    ak: this.sts.accessKeyID,
                    sk: this.sts.secretAccessKey
            },
            endpoint: 'https://bj.bcebos.com',
            sessionToken: this.sts.sessionToken
            };
        var vodConfig = {
            credentials: {
                    ak: this.sts.accessKeyID,
                    sk: this.sts.secretAccessKey
            },
            endpoint: 'https://vod.baidubce.com',
            sessionToken: this.sts.sessionToken
        };


        var client = new VodClient(vodConfig, bosConfig);
        let file_name = "";
        let file_blob = "";
        if(type == 1){
            file_name  = file.stream;
            file_blob = file.blob;
        }else{
            file_name  = file.name;
            file_blob = file.raw;
        }
        client.createMediaResource(file_name, file_name, file_blob)
        // Node.js中<data>可以为一个Stream、<pathToFile>；在浏览器中<data>为一个Blob对象
        .then(response => {
            // 上传完成
            console.log('上传完成');
            this.video_upload_status = 3;
            this.upload.media_id = response.body.mediaId;
            this.upload.url = 'https://gcik47gyt746q6nqdze.exp.bcevod.com/'+ this.upload.media_id+'/'+ this.upload.media_id +'.m3u8';
            this.upload.type = null;
            this.upload.file = null;

        })
        .catch(error => {
            console.log(error);
            this.$confirm('<div style="font-weight:700">视频上传失败</div>操作异常，请稍后重试', '', {
              confirmButtonText: '我知道了',
              cancelButtonText: '取消',
              customClass:'',
              dangerouslyUseHTMLString: true,
              showClose:false,
              showCancelButton:false,
              closeOnClickModal:false,
              type: 'error'
            }).then(() => {
                this.video_upload_status = 2;
            }).catch(() => {
            });
        })

    },
    // 查询试卷状态
    getPaperStatus (user_record_id, cb) {
      this.$api.GETPAPERSTATUS({
          user_record_id
      }).then((res) => {
          if(res.retcode == 0){
              this.is_view = res.data == 1 ? true : false;
              cb && cb();
          } else {
              this.$message.error(res.message);
          }

      }).catch((res) =>{
      })
    },
    // 视频上传
    videoUpload (obj) {
      // console.log('视频---------->', obj);
      this.upload.file = obj;
      this.upload.type = 1;
      this.fileUploadQiNiu(obj, 1);
    },
    // 录制视频组件错误处理器
    errorLister (err) {
      console.log(err);
      this.$confirm(err.message, err.title, {
        confirmButtonText: '我知道了',
        type: 'warning',
        // center: true,
        showClose:false,
        showCancelButton: false
      }).then(() => {
      }).catch(() => {
      });
    },
    RecordVideoOpen () {
      this.RecordVideo = true;
    },
    // 查看教师点评信息
    getPaperCorrectResult () {
      this.$api.GETPAPERCORRECTRESULT({
        record_id: this.$route.params.record_id,
        question_id: this.$route.params.question_id,
      }).then(res => {
        if (res.retcode == 0) {
          // 答题卡
          this.local_pic_arr = res.data.img_result.map(item => {
            this.http_pic_arr.push(item.correct_img);
            return {
              name: item.correct_img,
              url: item.correct_img
            }
          })
          // this.text_remark_id = res.data.text_remark.text_remark_id;
          // 教师评分
          this.num = res.data.teacher_score;
          if (res.data.text_result) {
              // 总体评价
              this.question_evaluation = res.data.text_result.question_evaluation;
              if (this.$refs.ueditor_1) {
                this.$refs.ueditor_1.setUEContent(this.question_evaluation);
              }
              // 问题
              this.question_issue = res.data.text_result.question_issue;
              // this.$refs.ueditor_2.setUEContent(this.question_issue);
              if (this.$refs.ueditor_2) {
                this.$refs.ueditor_2.setUEContent(this.question_issue);
              }
              // 优点
              this.question_merit = res.data.text_result.question_merit;
              // this.$refs.ueditor_3.setUEContent(this.question_merit);
              if (this.$refs.ueditor_3) {
                this.$refs.ueditor_3.setUEContent(this.question_merit);
              }
              // 建议
              this.question_advice = res.data.text_result.question_advice;
              // this.$refs.ueditor_4.setUEContent(this.question_advice);
              if (this.$refs.ueditor_4) {
                this.$refs.ueditor_4.setUEContent(this.question_advice);
              }
          }
          // 视频
          if (res.data.video_result && res.data.video_result.length) {
              this.upload.media_id = res.data.video_result[0].video_media_id;
              this.upload.url = res.data.video_result[0].video_url;
          }
        } else {
          // 区分修改还是新增
          if (res.retcode == 10001 && !this.is_view) {
            // 新增
            return this.isAdd = true;
          }
          this.$message.error(res.message);
        }
      })
    },
    // 获取批改说明阅读状态
    getUserCorrectExplain () {
      this.$api.GETUSERCORRECTEXPLAIN().then(res => {
        if (res.retcode == 0) {
          if (!res.data.set_status) {
            // 每次提醒
            this.goCorrectExplainView();
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    goCorrectExplainView () {
      let routeUrl = this.$router.resolve({
          path: "/correct-explain"
      });
      window.open(routeUrl .href, '_blank');
    },
    beforeUpload (a) {
      return new Promise((resolve, reject) => {
        if (this.http_pic_arr.length >= this.user_answer_sheet_length && !this.pic_toast) {
          this.$confirm('<p style="color:#bbb;">继续上传将超过学员答题卡数量，确定要上传吗？</p>', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose:false,
            closeOnClickModal:false,
            dangerouslyUseHTMLString:true,
            showCancelButton:true
          }).then(() => {
            resolve ('继续上传');
          }).catch(() => {
            reject('停止上传');
          });
          this.pic_toast = true;
          return;
        }
        resolve ('继续上传');
        // reject('停止上传');
      })
    },
    // 上传图片
    uploadFile (params) {
      var file = params.file
      var formData = new FormData();
      formData.append('img', file);
      this.$api.UPLOADIMAGE(formData).then(res => {
        this.pic_err_msg = '';
        if (res.retcode == 0) {
          this.http_pic_arr.push(res.data.img_url);
        } else {
          if (this.$refs.upload.uploadFiles.length) {
            this.$refs.upload.uploadFiles.splice(-1, 1);
          }
          this.$message.error(res.message);
        }
      }).catch(err => {
        if (this.$refs.upload.uploadFiles.length) {
          this.$refs.upload.uploadFiles.splice(-1, 1);
        }
      })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove (file) {
      let idx;
      this.$refs.upload.uploadFiles.forEach((item, index) => {
        if (item.url == file.url) {
          idx = index;
        }
      });
      this.$refs.upload.uploadFiles.splice(idx, 1);
      this.http_pic_arr.splice(idx, 1);
    },
    // 校验
    check () {
        if (this.need_score == 1 && (this.num == null || this.num == 'undefined')) {
            this.err_msg = '请输入教师评分';
            return false;
        }
        if (this.need_score == 1 && this.num > this.max_score ) {
            this.err_msg = `评分不能超过总分(${this.max_score})`;
            return false;
        }
        this.err_msg = '';
        return true;
    },
    check_pic () {
      if (!this.comment_mode.includes('0') && this.comment_mode.includes('3') && !this.http_pic_arr.length) {
        this.$message.error('答题卡批改为必填项');
        return false;
      }
      if (!this.comment_mode.includes('0') && this.comment_mode.includes('3') && this.http_pic_arr.length < this.user_answer_sheet_length) {
        this.pic_err_msg = '上传的图片数量小于学员答题卡数量';
        return false;
      }
      this.pic_err_msg = '';
      return true;
    },
    check_video () {
        if (!this.comment_mode.includes('0') && this.comment_mode.includes('2') && !this.upload.media_id) {
          this.$message.error('视频点评为必填项');
          return false;
        }
        return true;
    },
    check_words () {
      if (!this.comment_mode.includes('0') && this.comment_mode.includes('1')) {
        if (this.question_mode == 0) {
          // 作文题
          if (!this.$refs.ueditor_1.getUEContent()) {
            this.$message.error('总体评价为必填项');
            return false;
          }
          if (!this.$refs.ueditor_2.getUEContent()) {
            this.$message.error('问题为必填项');
            return false;
          }
          if (!this.$refs.ueditor_3.getUEContent()) {
            this.$message.error('优点为必填项');
            return false;
          }
          if (!this.$refs.ueditor_4.getUEContent()) {
            this.$message.error('建议为必填项');
            return false;
          }
        } else if (this.question_mode == 1) {
          if (!this.$refs.ueditor_2.getUEContent()) {
            this.$message.error('问题为必填项');
            return false;
          }
        } else {
          if (!this.$refs.ueditor_1.getUEContent()) {
            this.$message.error('文字点评为必填项');
            return false;
          }
        }
        return true;
      }
      return true;
    },
    cancel () {
      console.log('取消操作');
      window.close();
    },
    save () {
      if (this.video_upload_status == 1 ||  this.video_upload_status == 2) {
        this.$confirm('视频正在上传，无法保存', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass:'video-know-position',
          dangerouslyUseHTMLString: true,
          showClose:false,
          showCancelButton:true,
          closeOnClickModal:false,
          type: 'error'
        }).then(() => {
        }).catch(() => {
        });
        return;
      }
      // 校验
      if (this.check() && this.check_pic() && this.check_video() && this.check_words()) {
        var params = {
          tiku_paper_id: this.$route.params.tiku_paper_id,
          iip_paper_id: this.$route.params.iip_paper_id,
          user_record_id: this.$route.params.record_id,
          question_id: this.$route.params.question_id,
          comment_mode: this.$route.params.comment_mode,
          tiku_user_id: this.$route.params.user_id,
          sso_id: Number(this.$route.params.sso_id),
          question_type: this.question_mode
        }
        // 教师评分
        if (this.need_score == 1) {
          params.teacher_score = this.num;
        }
        // 文字点评
        if (!this.comment_mode.includes('0') && this.comment_mode.includes('1')) {
          if (this.question_mode == 0) {
            params.question_evaluation = this.$refs.ueditor_1.getUEContent();
            params.question_issue = this.$refs.ueditor_2.getUEContent();
            params.question_merit = this.$refs.ueditor_3.getUEContent();
            params.question_advice = this.$refs.ueditor_4.getUEContent();
          } else if (this.question_mode == 1) {
            params.question_issue = this.$refs.ueditor_2.getUEContent();
          } else {
            params.question_evaluation = this.$refs.ueditor_1.getUEContent();
          }
        }
        // 答题卡
        if (!this.comment_mode.includes('0') && this.comment_mode.includes('3')) {
          params.correct_img_data = JSON.stringify(this.http_pic_arr);
        }
        // 视频点评
        if (!this.comment_mode.includes('0') && this.comment_mode.includes('2')) {
          params.video_url = this.upload.url;
          params.video_media_id = this.upload.media_id;
        }
        // 修改
        if (!this.isAdd) {
          params.action_id = 1;
          this.$api.ADDPAPERCORRECTQUESTIONRESULT(params).then(res => {
            if (res.retcode == 0) {
                console.log('修改教师点评-添加成功');
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  onClose: () => {
                    window.close();
                  }
                });
            } else {
              this.$message.error(res.message);
            }
          })
          return;
        }
        // 添加
        // 接口
        params.action_id = 0;
        this.$api.ADDPAPERCORRECTQUESTIONRESULT(params).then(res => {
            if (res.retcode == 0) {
                console.log('教师点评-添加成功');
                // 通知父组件已点评
                var bc = new BroadcastChannel('paper_channel');
                bc.postMessage(this.$route.params.question_id);
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  onClose: () => {
                    window.close();
                  }
                });
            } else {
              this.$message.error(res.message);
            }
        })
      }

    }
  }
}
</script>

<style lang="less" scoped>
.paper-assess-page {
  height: 100%;
  .inputErrorMessage{
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .font-12 {
    font-size: 12px;
  }
  .page-title {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .words-box {
      height: 100%;
      flex: 1 0 auto;
      display: flex;
      align-items: center;
      height: fit-content;
      // align-self: center;
      .title {
        font-size: 20px;
        font-weight: bolder;
        margin-right: 10px;
      }
      .name {
        margin-left: 40px;
      }
    }
    .button-box {
      height: fit-content;
    }
  }
  .page-content {
    padding: 80px 50px 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .part {
      margin: 20px 0 0;
      .red {
        color: red;
      }
      .part-title {
        font-weight: bolder;
        margin: 0 0 20px;
      }
      .part-content {
        .item-title {
          &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 4px;
              height: 17px;
              width: 3px;
              background-color: #1890ff;
          }
          font-size: 14px;
          font-weight: bolder;
          position: relative;
          height: 25px;
          padding-left: 5px;
          margin: 10px 0;
        }
        .item-content {
          margin: 0 0 20px;
        }
        .icon-v{
            width: 15px;
            height: 15px;
            margin-right: 5px;
        }
        .font-video{
            color: #606266;
        }
        .rela{
            position: relative;
        }
        .upload-success{

            width: 30%;
            padding-right: 40px;
            padding-left: 8px;
            box-sizing: border-box;
            display: inline-block;
            background-color: #f2f2f2;
            position: relative;
            height: 40px;
            line-height: 40px;
            vertical-align: middle;
            /*margin-right: 6px;*/
            .el-icon-close{
                color: #606266;
                font-size: 20px;
                position: absolute;
                right: 4px;
                top: 11px;
                cursor: pointer;
            }


        }
        .upload-success-info{
            width: 100%;
            color: #409EFF;
            display: inline-block;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;

        }
        .upload-success-id{
            color: #606266;
            width: 60%;
            overflow: hidden;
            float: left;
            margin-right: 10px;
        }
        .upload-success-url{
            color: #409EFF;
            width: 100%;
            cursor: pointer;
        }
        .no-video{
            // position: absolute;
            // right: 2px;
            // top:0;
        }
        .video-upload{
            display: inline-block;
        }
        .video-style {
            color: #409EFF;
            cursor: pointer;
        }
      }
    }
  }
  .rotate-self{
    animation:turn 1s linear infinite;
  }
  @keyframes turn{
      0%{transform:rotate(0deg);}
      25%{transform:rotate(90deg);}
      50%{transform:rotate(180deg);}
      75%{transform:rotate(270deg);}
      100%{transform:rotate(360deg);}
  }
}
</style>
<style>
.paper-assess-page .page-content .is_view .el-upload.el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/paper-assess/index.vue